import { useModalServiceStore } from './service-store/service-store';
import { checkEqual } from 'common/helpers/checkEqual';
export var useModalActions = function () {
    return useModalServiceStore(function (state) { return ({
        addModal: state.addModal,
        hideLastModal: state.hideLastModal,
        removeModal: state.removeModal,
    }); }, checkEqual);
};
